import { IconButton } from "@similarweb/ui-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

import SignalView from "../Signal";

export const StyledButton = styled(IconButton)`
    & svg path {
        fill-opacity: 1;
    }
`;

export const StyledButtonWrap = styled.div`
    flex-shrink: 0;

    &:not(:first-child) {
        margin-left: 4px;
    }
`;

const StyledButtonsWrapper = styled(FlexRow)`
    flex-shrink: 0;
    margin-left: 8px;
`;

export const StyledHiddenButtonsWrapper = styled(StyledButtonsWrapper)`
    opacity: 0;
    pointer-events: none;
    transition: opacity 300ms ease-out;
`;

export const StyledSignalView = styled(SignalView)`
    &:hover {
        ${StyledHiddenButtonsWrapper} {
            opacity: 1;
            pointer-events: auto;
        }
    }
`;
